module.exports = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'http://localhost:5000'
};